import SiteButton_ShinyButtonInvertedComponent from '../components/SiteButton/viewer/skinComps/ShinyButtonInverted/ShinyButtonInverted.skin';
import SiteButton_ShinyButtonInvertedController from '../components/SiteButton/viewer/SiteButton.controller';


const SiteButton_ShinyButtonInverted = {
  component: SiteButton_ShinyButtonInvertedComponent,
  controller: SiteButton_ShinyButtonInvertedController
};


export const components = {
  ['SiteButton_ShinyButtonInverted']: SiteButton_ShinyButtonInverted
};

